import { render } from "./BatteryPercentIcon.vue?vue&type=template&id=159f9d91&scoped=true"
import script from "./BatteryPercentIcon.vue?vue&type=script&lang=js"
export * from "./BatteryPercentIcon.vue?vue&type=script&lang=js"

import "./BatteryPercentIcon.vue?vue&type=style&index=0&id=159f9d91&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159f9d91"]])

export default __exports__